import { configureStore } from "@reduxjs/toolkit";
import CommonStore from "./CommonStore";

export default configureStore({
  reducer: {
    CommonStore: CommonStore,
  },
});
